import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledButton = styled(MuiButton)(({ theme }) => {
  return {
    backgroundColor:
      theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
    color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : "#0b1b37",
    borderRadius: "6.25rem",
    textTransform: "none",
    padding: "0.25rem 1.25rem",
    width: "fit-content",

    "&.Mui-disabled": {
      backgroundColor:
        theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
      color: "#7f8794",
    },

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "light"
          ? brandColors.primaryButtonHoverLight
          : brandColors.primaryButtonHoverDark,
    },
  };
});

interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode;
}

export const PrimaryButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

export default PrimaryButton;
